export default "__VITE_ASSET__BfWxQn$o__"